module.exports = __webpack_public_path__ + "img/logo.deb8dcb1.svg";